<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
  <div class="input-checkbox-wrapper">
    <input type='file' autoComplete="off" class="input-import" accept='.csv' multiple (change)='openFile($event)'>
    <mat-checkbox style="margin-left: 15px;" [(ngModel)]="deleteTravelMixes">Delete TravelMixes from old region</mat-checkbox>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button class="color" (click)="cancel()">{{button1}}</button>
  <span class="spacer"></span>
  <button mat-button class="color" (click)="importFile()" [(disabled)]="isImportButtonDisabled" cdkFocusInitial>{{button2}}</button>
</mat-dialog-actions>